import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import SendingModalWrapper from '../sendingModalWrapper/SendingModalWrapper';
import * as css from './TrialSendingPopup.css';
import {TShow} from '../../../prompotionPopup/PromotionPopup';
import TrialFormSection from './TrialFormSection';
import {getStaticImage} from '../../../../globalVariables/GlobalVariables';
import {sendingImage} from '../../icons/images';
interface TrialSendingPopupProps {
    show: TShow;
    onSend: (contacts: string[]) => void;
    contactType: 'phone' | 'email';
    maxContacts?: number;
    namespace?: string;
    title?: string;
    description?: string;
}

function TrialSendingPopup({show, onSend, contactType, maxContacts = 3, namespace = 'mailing', title, description}: TrialSendingPopupProps) {
    const {t} = useTranslation(namespace);
    const formRef = useRef(null);

    const getLabels = () => {
        const baseLabels = {
            title: title || t('trialTitle'),
            send: t('send')
        };

        if(contactType === 'email') {
            return {
                ...baseLabels,
                placeholder: t('emailPlaceholder'),
                label: t('emailAddress'),
                addAnother: t('addAnotherEmail')
            };
        } else {
            return {
                ...baseLabels,
                placeholder: t('phoneNumberPlaceholder'),
                label: t('phoneNumber'),
                addAnother: t('addAnotherPhone')
            };
        }
    };

    const labels = getLabels();
    const handleSubmit = () => {
        formRef.current.handleSubmit();
    };
    const buttons = {
        whiteBtn: {
            text: 'close',
            onClick: show.close
        },
        blueBtn: {
            text: 'send',
            onClick: handleSubmit
        }
    };

    return (
        <css.container>
            <SendingModalWrapper
                show={show}
                title={labels.title}
                buttons={buttons}
                dataCy={`trial${contactType}`}
                headerImage={getStaticImage(sendingImage)}
            >
                <css.title>{t('responsibleProducer')}</css.title>
                <css.description>{description || t('trialDescription')}</css.description>
                <TrialFormSection
                    contactType={contactType}
                    maxContacts={maxContacts}
                    namespace={namespace}
                    onSend={onSend}
                    onClose={show.close}
                    formRef={formRef}
                    labels={labels}
                />
            </SendingModalWrapper>
        </css.container>
    );
}

export default TrialSendingPopup;
